module.exports = __webpack_public_path__ + "static/media/exploreIcon.157945ff.svg";